import { classNames } from "primereact/utils";
import { IPreReservationFormInputModel } from "../models/preReservationFormInputModel";
import styles from "./PreReservationFormListItem.module.scss";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";

interface IPreReservationFormListItemProps {
  className?: string;
  item?: IPreReservationFormInputModel;
  isLoading: boolean;
  actionButtons?: React.ReactNode;
}

export const PreReservationFormListItem = ({
  className,
  item,
  isLoading,
  actionButtons,
}: IPreReservationFormListItemProps) => {
  return (
    <div
      className={classNames(className, styles.item, {
        [styles.item_deleted]: item?.isDeleted,
      })}
    >
      <div className={styles.item_skeleton_wrapper}>
        <SkeletonItem
          isLoading={isLoading}
          value={
            <div className={styles.item_main}>
              <div className={styles.item_main_name}>
                {item?.name}
                <span className={styles.item_main_name_id}>
                  (ID: {item?.id})
                </span>
              </div>
            </div>
          }
        />
      </div>
      {actionButtons}
    </div>
  );
};
